document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qc-acc-btn]');
  if (!btn) return;
  const item = btn.closest('.qc-acc-item');
  const panel = item.querySelector('.qc-acc-panel');
  const open = panel.classList.contains('is-open');
  panel.classList.toggle('is-open', !open);
  btn.setAttribute('aria-expanded', String(!open));
});
